import styled from '@emotion/styled';

const Button = styled.button`
  cursor: pointer;
`;

export { Button };
